/**
 * @name isValidNumber
 *
 * @description Returns if a passed in parameter is a valid number
 *
 * @example
 * import { isValidNumber } from '@workbench/core';
 *
 * isValidNumber(17); // true
 * isValidNumber(0); // true
 * isValidNumber('5'); // true
 * isValidNumber(NaN); // false
 * isValidNumber('hello'); // false
 */
export const isValidNumber = (value: unknown): boolean => {
  if (value === 0) {
    return true;
  }

  if (typeof value === 'number' && isNaN(value as number)) {
    return false;
  }

  return value && isNaN(+value) === false && typeof +value === 'number';
};
